import appRoutes from './app';
import tmRoutes from './tm';
import nsRoutes from './ns';
import crsRoutes from './crs';
import trmRoutes from './trm';
import CMRoutes from './cm';
import sandboxRoutes from './sandbox';

export {
  appRoutes,
  tmRoutes,
  nsRoutes,
  crsRoutes,
  trmRoutes,
  CMRoutes,
  sandboxRoutes
};
